// components/Header.js
import React, { useEffect, useState } from 'react';
import '../Styles/Header.css';
import { FaBars } from 'react-icons/fa'; // burger icon

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      const sections = document.querySelectorAll('section');
      sections.forEach(section => {
        const top = section.offsetTop - 80;
        const bottom = top + section.offsetHeight;
        if (window.scrollY >= top && window.scrollY <= bottom) {
          setActiveSection(section.id);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({ top: element.offsetTop - 70, behavior: 'smooth' });
      setMenuOpen(false); // close menu after click
    }
  };

  return (
    <header className={`main-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo">
          <span className="iqube-text">IQube</span> Technologies
        </div>
        <div className="burger-icon" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </div>
        <nav className={menuOpen ? 'show' : ''}>
          <ul>
            <li className={activeSection === 'home' ? 'active' : ''}><span onClick={() => scrollToSection('home')}>Home</span></li>
            <li className={activeSection === 'about' ? 'active' : ''}><span onClick={() => scrollToSection('about')}>About</span></li>
            <li className={activeSection === 'clients' ? 'active' : ''}><span onClick={() => scrollToSection('clients')}>Clients</span></li>
            <li className={activeSection === 'services' ? 'active' : ''}><span onClick={() => scrollToSection('services')}>Services</span></li>
            <li className={activeSection === 'testimonials' ? 'active' : ''}><span onClick={() => scrollToSection('testimonials')}>Testimonials</span></li>
            <li className={activeSection === 'contact' ? 'active' : ''}><span onClick={() => scrollToSection('contact')}>Contact</span></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
